import React from "react";
import { Link } from "react-router-dom";

/**
 * Banner shown when a user's 72-hour trial has expired and they don't have lifetime.
 * Pages that gate mutations should render this above the gated UI.
 */
export default function TrialLockBanner({ trial, message }) {
  if (!trial || trial.status === "lifetime" || !trial.expired) return null;
  return (
    <div className="card-glass p-4 mb-6 border border-red-500/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" data-testid="trial-lock-banner">
      <div className="flex items-start gap-3 min-w-0">
        <div className="w-9 h-9 rounded-full bg-red-500/15 flex items-center justify-center shrink-0">
          <svg className="w-4 h-4 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <div className="min-w-0">
          <h3 className="text-white font-semibold text-sm">Read-only mode — your trial has expired</h3>
          <p className="text-[#E8E4DC]/80 text-xs mt-0.5">
            {message || "Existing data is still visible, but creating or editing requires lifetime access."}
          </p>
        </div>
      </div>
      <Link
        to="/pricing"
        className="bg-[#A3E635] text-black px-4 py-2 rounded-full font-bold text-xs hover:bg-[#8CD025] transition-all whitespace-nowrap"
        data-testid="trial-lock-upgrade-btn"
      >
        Get Lifetime — $39
      </Link>
    </div>
  );
}
